import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { setBlazeDebug, getFromLocal } from '../../helpers';
import { BLAZE_DEBUG } from '../../constants';

const DebugSidebar = dynamic(() => import('./DebugSidebar'));

const DebugSidebarRender = ({ itemEntity, itemId, updatedDebugOptions, debugMode }) => {
  const [isDebugMode, setIsDebugMode] = useState(debugMode);
  const router = useRouter();

  useEffect(() => {
    const currentDebugValue = getFromLocal(BLAZE_DEBUG);
    setIsDebugMode(currentDebugValue);
    setBlazeDebug(setIsDebugMode);
  }, []);

  useEffect(() => {
    const handleRouteChange = url => {
      const hasDebug = url.includes(`${BLAZE_DEBUG}=1`);
      if (hasDebug) {
        setBlazeDebug(setIsDebugMode);
      }
    };

    if (router.asPath.includes(`${BLAZE_DEBUG}=1`)) {
      handleRouteChange(router.asPath);
    }

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, router.asPath]);

  if (!isDebugMode) return null;

  return (
    <DebugSidebar
      itemEntity={itemEntity}
      itemId={itemId}
      updatedDebugOptions={updatedDebugOptions}
      debugMode={debugMode}
      setIsDebugMode={setIsDebugMode}
    />
  );
};

DebugSidebarRender.propTypes = {
  updatedDebugOptions: PropTypes.func.isRequired,
  itemEntity: PropTypes.string,
  itemId: PropTypes.string,
  debugMode: PropTypes.bool
};

DebugSidebarRender.defaultProps = {
  itemEntity: '',
  itemId: '',
  debugMode: false
};

export default DebugSidebarRender;
